export enum WorkShiftRequireWork {
  IN_WORKING_DAYS = 0,
  IN_WORKING_DAYS_AND_DAYS_OFF = 1,
  ALWAYS = 2,
  IF_PRESENT = 3,
}
